import clsx from 'clsx'
import { Fragment, type ReactNode } from 'react'
import { View } from 'react-native'

import { PlaceholderLine } from '@/src/elements/placeholder'
import { Placeholder } from '@/src/elements/placeholder/Placeholder'

export const itemClassName = 'mx-auto w-screen max-w-[650px] px-8 md:w-[720px]'

const ItemSeparatorComponent = (): ReactNode => <View className="h-3" />

const PublicationPlaceholder = (): ReactNode => (
  <View className={clsx(itemClassName, 'flex-row pt-9 pb-2')}>
    <View className="w-16 items-center justify-center">
      <Placeholder />
    </View>
    <View className="flex-col rounded-md flex-1 gap-2 pr-5">
      <View className="flex-row justify-between">
        <PlaceholderLine className="h-6 w-12 rounded-md " contrast="dark" />
        <PlaceholderLine className="h-6 w-14 rounded-md " contrast="dark" />
      </View>
      <PlaceholderLine className="h-10 rounded-md" contrast="dark" />
      <View className="flex-row gap-2">
        <PlaceholderLine className="h-8 w-16 rounded-md" contrast="dark" />
        <PlaceholderLine className="h-8 w-16 rounded-md" contrast="dark" />
      </View>
    </View>
  </View>
)

export const PublicationPlaceholders = ({ nb = 3 }: { nb?: number }): ReactNode =>
  Array.from({ length: nb }, (_, index) => (
    <Fragment key={index}>
      <PublicationPlaceholder key={index} />
      {index !== nb - 1 && <ItemSeparatorComponent />}
    </Fragment>
  ))
